// extracted by mini-css-extract-plugin
export default {"container":"FunnelProductsDetails_container__C54ut","title":"FunnelProductsDetails_title__R97X+","angles":"FunnelProductsDetails_angles__00msz"};